import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SharjahPoliceEmblem } from '../SharjahPoliceEmblem';
const PAIR2_LOGO = 'https://cdn.magicpatterns.com/uploads/51QRCG1WJpxN6EwND9yhQF/Pair2_(2).svg';
const SECTIONS = ['نبذة عن Pair²', 'محدوديه انظمة التتبع المتاحه', 'محدوديه انظمة التتبع المتاحه', 'الحل', 'منظومة Pair²', 'آلية التسجيل', 'رحلة تسجيل السائق', 'تسجيل وتفعيل الدراجة', 'ضبط النطاق التشغيلي', 'المراقبة الاستباقية لسلوك السائقين', 'الأثر الأمني والمروري'];
export function IndexSlide() {
  const reduce = useReducedMotion();
  const base = reduce ? {
    duration: 0
  } : undefined;
  return <section dir="rtl" className="relative w-screen h-screen overflow-hidden flex flex-col" style={{
    background: '#EDF1F4'
  }} data-id="element-484">
      {/* ===== BACKGROUND ===== */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden data-id="element-485">
        <div className="absolute -top-40 -right-40 w-[60vmax] h-[60vmax] rounded-full blur-3xl" style={{
        background: 'radial-gradient(circle, rgba(47,169,156,0.06) 0%, transparent 70%)'
      }} data-id="element-486" />
        <div className="absolute -bottom-40 -left-40 w-[50vmax] h-[50vmax] rounded-full blur-3xl" style={{
        background: 'radial-gradient(circle, rgba(47,169,156,0.04) 0%, transparent 70%)'
      }} data-id="element-487" />
        <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h40v40H0V0zm1 1h38v38H1V1z' fill='%230B1328' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E")`
      }} data-id="element-488" />
      </div>

      {/* ===== TOP BAR ===== */}
      <motion.div initial={{
      opacity: 0,
      y: -14
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={base ?? {
      duration: 0.9,
      delay: 0.15,
      ease: [0.22, 1, 0.36, 1]
    }} className="relative z-20 flex items-center justify-between pt-[clamp(1.5rem,3.5vh,3rem)] px-[clamp(1.75rem,4.5vw,4.5rem)] shrink-0" data-id="element-489">
        <SharjahPoliceEmblem variant="light" data-id="element-490" />
        <img src={PAIR2_LOGO} alt="Pair²" className="h-[clamp(2.5rem,5vh,3.5rem)] w-auto" style={{
        filter: 'drop-shadow(0 4px 18px rgba(47,169,156,0.28))'
      }} draggable={false} data-id="element-491" />
      </motion.div>

      {/* ===== MAIN CONTENT ===== */}
      <div className="relative z-20 flex-1 flex flex-col items-center justify-center px-[clamp(3rem,6vw,8rem)] pb-[clamp(1rem,2vh,1.5rem)]" data-id="element-492">
        {/* Title */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={base ?? {
        duration: 0.8,
        delay: 0.2
      }} className="font-arabic-display font-black text-center mb-2 leading-[1.15]" style={{
        color: '#0B1328',
        fontSize: 'clamp(1.5rem, 2.5vw, 2rem)'
      }} data-id="element-493">
          فهرس العرض
        </motion.h2>

        {/* Teal underline */}
        <motion.div initial={{
        opacity: 0,
        scaleX: 0
      }} animate={{
        opacity: 0.45,
        scaleX: 1
      }} transition={base ?? {
        duration: 0.6,
        delay: 0.35
      }} className="mx-auto h-[2.5px] rounded-full mb-[clamp(1rem,2vh,1.5rem)]" style={{
        width: 'clamp(3rem, 5vw, 4rem)',
        background: '#2FA99C'
      }} data-id="element-494" />

        {/* Index List */}
        <div className="w-full max-w-2xl flex flex-col gap-[clamp(0.15rem,0.4vh,0.35rem)]" data-id="element-495">
          {SECTIONS.map((title, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={base ?? {
          duration: 0.5,
          delay: 0.4 + i * 0.07
        }} className="flex items-center gap-3 py-[clamp(0.35rem,0.6vh,0.5rem)] px-[clamp(0.75rem,1.5vw,1.25rem)] rounded-lg transition-colors duration-200" style={{
          background: i % 2 === 0 ? 'rgba(255,255,255,0.5)' : 'transparent',
          borderBottom: '1px solid rgba(47,169,156,0.08)'
        }} data-id="element-496">
              {/* Number */}
              <div className="w-7 h-7 rounded-md flex items-center justify-center shrink-0 font-bold" style={{
            background: 'rgba(47,169,156,0.1)',
            color: '#2FA99C',
            fontSize: 'clamp(0.7rem, 0.9vw, 0.85rem)',
            border: '1px solid rgba(47,169,156,0.2)'
          }} data-id="element-497">
                {(i + 1).toLocaleString('ar-EG')}
              </div>

              {/* Title */}
              <span className="font-arabic-body font-semibold text-right flex-1" style={{
            color: '#0B1328',
            fontSize: 'clamp(0.85rem, 1.1vw, 1.05rem)'
          }} data-id="element-498">
                {title}
              </span>

              {/* Decorative dot */}
              <div className="w-1.5 h-1.5 rounded-full shrink-0" style={{
            background: 'rgba(47,169,156,0.3)'
          }} data-id="element-499" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}